import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

type ValidateCode = {
  Codigo: string;
  UnidadeId: string;
  SafraId: string;
}

export function useGetValidateCode() {
  return useMutation(URL.PLANO_OPERACIONAL.OBTER_VALIDACAO_CODIGO, async (body: ValidateCode) => {
    const response = await http.post(URL.PLANO_OPERACIONAL.OBTER_VALIDACAO_CODIGO, body);
    return response;
  });
}
export function useGetValidateDescription() {
  return useMutation(URL.PLANO_OPERACIONAL.OBTER_VALIDACAO_DESCRICAO, async (body: ValidateCode) => {
    const response = await http.post(URL.PLANO_OPERACIONAL.OBTER_VALIDACAO_DESCRICAO, body);
    return response;
  });
}

export default useGetValidateCode;
